$(document).ready(function(){
    if($('.collection_filter').length > 0) {
        var collectionFilter = $('.collection_filter').offset().top;
        $(window).scroll(function () {
            var currentScroll = $(window).scrollTop();
            if (currentScroll > collectionFilter) {
                $('.collection_filter').addClass('filter-active');
                $('.filter-overlay').addClass('active');
            } else {
                $('.collection_filter').removeClass('filter-active');
                $('.filter-overlay').removeClass('active');
            }
        });
    }


    $('.js-collection-tab').click(function () {
        const index = $(this).attr('data-tab')
        $('.js-collection-tab').removeClass('active')
        $('.index-products-slider').removeClass('active')

        $(this).addClass('active')
        $(`[data-slide="${index}"]`).addClass('active')
    })

    $('.js-slide-arrow').click(function (){
        if($(this).hasClass('prev')) {
            $(this).parents('.feature-collection-tabs').find('.active .testimonials__slider-arrow--left').click()
        } else {
            $(this).parents('.feature-collection-tabs').find('.active .testimonials__slider-arrow--right').click()
        }
    })

    $('.accordion-faq-title').click(function (){
       $(this).toggleClass('active')
        $(this).next().slideToggle()
    })

    $('.btn__show__more button').click(function () {
        $('.product__wrapper').toggleClass('is_show_more')
    })

    let isIOS = /iPad|iPhone|iPod/.test(navigator.platform)

    if (isIOS) {
        $('.product__wrapper').addClass('ios_device')
    }

    const fonts = document.querySelectorAll('.template-product .product-list.list-font .font-name')
    const mainImageDesk = document.querySelectorAll('.template-product .main_desk_image')
    const productWrapper = document.querySelector('.product__wrapper')
    const addClass = (el, classAdded = 'hide') => {
        if (!el || !el.classList) {
            console.warn('Element is not found')
        }

        el.classList.add(classAdded)
    } 

    const removeClass = (el, classAdded = 'hide') => {
        if (!el || !el.classList) {
            console.warn('Element is not found')
        }

        el.classList.remove(classAdded)
    } 

    const select = (classItem) => {
        if (!classItem) {
            console.warn('Element is not found')

            return null
        }

        return document.querySelector(classItem)
    } 

    const selectAll = (classItem) => {
        if (!classItem) {
            console.warn('Element is not found')
            return []
        }

        return document.querySelectorAll(classItem)
    } 

    if (fonts) {
        fonts.forEach(item => {
            item.addEventListener('click', () => {
                fonts.forEach(itm => itm.classList.remove('active'))
                item.classList.add('active')
                const inputTypeFont = select('.template-product .input__type__font')
                const dataAttribute = item.getAttribute('data-font-item')
                const value = dataAttribute === 'type_1' ? 'Lucinda Caligraphy' : dataAttribute === 'type_2' ? 'Melinda Script' : 'Azo Sans'
                inputTypeFont.value = value
                productWrapper.setAttribute('data-font-type', dataAttribute)
                // mainImageDesk.forEach(itm => itm.querySelector('.main_image').setAttribute('data-font-type', dataAttribute))
            })
        })
    }

    const btnReadMore = document.querySelector('.template-product .product__read-more')
    if (btnReadMore) {
        btnReadMore.addEventListener('click', () => {
            const productDesc = document.querySelector('.template-product .product__description')
            const descClass = productDesc.classList
            if (descClass.value.includes('active')) {
                descClass.remove('active')
                btnReadMore.textContent = 'Read more'
            } else {
                descClass.add('active')
                btnReadMore.textContent = 'Read less'
            }
        })
    }

    const options = document.querySelectorAll('.template-product .option__fingerprint__item');
    const fingerSelect = document.querySelector('.template-product .fingerprint__selection');

    if (options && fingerSelect) {
        options.forEach(option => {
            option.addEventListener('click', (e) => {
                const inputName = document.querySelector('.product-list-details .dob_charater');
                const inputDOB = document.querySelector('.product-list-details .birth_day_character');
                const isHide = inputDOB?.classList?.value?.includes('hide')

                options.forEach(op => op.classList.remove('active'))
                option.classList.add('active')
                fingerSelect.value = option.getAttribute('data-option-finger');
                fingerSelect.dispatchEvent(new Event('change'));

                // if (inputName?.value === '' && (isHide || !isHide && inputDOB?.value !== '')) {
                //     fingerSelect.dispatchEvent(new Event('change'));
                // }

                const imageSrc = option.querySelector('.option__fingerprint__image img')?.getAttribute('src')
                const photos = document.querySelectorAll('.main_desk_image.active .main_image .product__photo')
                if (imageSrc && photos?.length > 0) {
                    photos.forEach(photo => photo.classList.remove('duo_option_selected'))
                    photos.forEach(photo => {
                        if (imageSrc === photo?.getAttribute('data-image-src')) {
                            photo.classList.add('duo_option_selected')
                            return
                        }
                    })
                }
                // const thumbnailSlide = document.querySelectorAll('.main_desk_image.active .thumb_slider .product__photo--additional')
                // if (imageSrc && thumbnailSlide?.length > 0) {
                //     thumbnailSlide.forEach(thumb => {
                //         if (imageSrc === thumb?.getAttribute('data-image-src')) thumb?.click()
                //     })
                // }
            })
        })
    }
    
    const btnStickyView = document.querySelector('.template-product .product__sticky__view');

    if (btnStickyView) btnStickyView.addEventListener('click', () => {
        const productMainActive = document.querySelector('.product__page .main_desk_image.active')
        const productImageActive = productMainActive?.querySelector('.slick-list .slick-active')
        const productMainImage = productMainActive?.querySelector('.main_image')
        const productZoomMobile = document.querySelector('.product__zoom__mobile')
        const productZoomImageContainer = document.querySelector('[data-zoom-container]')
        const productZoomImage = productZoomImageContainer?.querySelector('.product__zoom__image')
        if (productImageActive && productZoomMobile && productMainImage && productZoomImage) {
            const colorClass = productMainActive.classList.value
            productZoomImageContainer.setAttribute('data-font-type', productMainImage.getAttribute('data-font-type'))
            productZoomImageContainer.setAttribute('data-engraving-type', productMainImage.getAttribute('data-engraving-type'))
            productZoomImageContainer.className = colorClass
            productZoomImage.innerHTML = productImageActive.innerHTML
            productZoomMobile.classList.remove('hide')
        }
    })

    const btnZoomClose = document.querySelector('.template-product .product__zoom__close');

    if (btnZoomClose) btnZoomClose.addEventListener('click', () => {
        const productZoomImage = document.querySelector('.product__zoom__image')
        const productZoomImageContainer = document.querySelector('[data-zoom-container]')
        const productZoomMobile = document.querySelector('.product__zoom__mobile')
        if (productZoomImage && productZoomMobile && productZoomImageContainer) {
            productZoomImage.innerHTML = ''
            productZoomMobile.classList.add('hide')
            productZoomImageContainer.className = ''
        }
    })

    const btnFingerModalClose = document.querySelector('.template-product .modal-btn-close');

    if (btnFingerModalClose) btnFingerModalClose.addEventListener('click', () => {
        const btn = document.querySelector('#finger-print-faqs-modal .carousel__button')
        btn?.click()
    })
});